"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  text-align: center;\n"], ["\n  height: ", ";\n  text-align: center;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  background-color: ", ";\n  border-radius: 50%;\n  display: inline-block;\n  height: ", ";\n  margin: ", ";\n  vertical-align: top;\n  width: ", ";\n\n  &:nth-child(6) {\n  }\n\n  &:nth-child(5) {\n    animation-delay: 100ms;\n  }\n\n  &:nth-child(4) {\n    animation-delay: 200ms;\n  }\n\n  &:nth-child(3) {\n    animation-delay: 300ms;\n  }\n\n  &:nth-child(2) {\n    animation-delay: 400ms;\n  }\n\n  &:nth-child(1) {\n    animation-delay: 500ms;\n  }\n"], ["\n  ", ";\n  background-color: ", ";\n  border-radius: 50%;\n  display: inline-block;\n  height: ", ";\n  margin: ", ";\n  vertical-align: top;\n  width: ", ";\n\n  &:nth-child(6) {\n  }\n\n  &:nth-child(5) {\n    animation-delay: 100ms;\n  }\n\n  &:nth-child(4) {\n    animation-delay: 200ms;\n  }\n\n  &:nth-child(3) {\n    animation-delay: 300ms;\n  }\n\n  &:nth-child(2) {\n    animation-delay: 400ms;\n  }\n\n  &:nth-child(1) {\n    animation-delay: 500ms;\n  }\n"]);

var _arenaConfig = require("arena-config");

var c = _interopRequireWildcard(_arenaConfig);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("../propTypes");

var _mixins = require("./mixins");

var _propTypes2 = require("./propTypes");

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var DotsOuter = _styledComponents2.default.div(_templateObject, function (props) {
  return (0, _styles.dotHeight)(props);
});

var DotsInner = _styledComponents2.default.div(_templateObject2);

var StyledDot = _styledComponents2.default.div(_templateObject3, function (props) {
  return (0, _mixins.animateDot)(props.dotSpeed);
}, function (props) {
  return c.color(props);
}, function (props) {
  return (0, _styles.dotHeight)(props);
}, function (props) {
  return (0, _styles.dotMargin)(props);
}, function (props) {
  return (0, _styles.dotHeight)(props);
});

var prepareColorProps = function prepareColorProps(props) {
  return {
    red: props.red,
    orange: props.orange,
    yellow: props.yellow,
    green: props.green,
    blue: props.blue,
    purple: props.purple,
    pink: props.pink,
    black: props.black,
    darkestGray: props.darkestGray,
    darkerGray: props.darkerGray,
    darkGray: props.darkGray,
    gray: props.gray,
    lightGray: props.lightGray,
    lighterGray: props.lighterGray,
    lightestGray: props.lightestGray,
    white: props.white
  };
};

var Dots = function Dots(props) {
  var Dot = _react2.default.createElement(StyledDot, _extends({}, prepareColorProps(props), {
    dotHeight: props.dotHeight,
    dotSpeed: props.dotSpeed
  }));

  return _react2.default.createElement(DotsOuter, {
    dotHeight: props.dotHeight
  }, _react2.default.createElement(DotsInner, null, Dot, Dot, Dot, Dot, Dot, Dot));
};

Dots.defaultProps = _extends({}, _propTypes.animationCommonDefaultProps, _propTypes2.dotsDefaultProps);
Dots.propTypes = _extends({}, _propTypes.animationCommonPropTypes, _propTypes2.dotsPropTypes);
exports.default = Dots;